export const lessonModifiedAt = (state) => state.lesson?.selectedScenario?.modifiedAt
export const lessonGenerationIndex = (state) => state.lesson?.selectedScenario?.generationIndex
